export default __webpack_public_path__ + "images/d6adac113dc4b6b20658fd12c480f4e4.svg";